import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import Questionnaire from './apis/Questionnaire.js'
import Cart from './apis/Cart.js'
import User from './apis/User.js'
import Coupon from './apis/Coupon.js'
import Vendor from './apis/Vendor.js'
import Design from './apis/Design.js'
import Ownership from './apis/Ownership.js'
import Article from './apis/Article.js'
import Organization from './apis/Organization.js'
import MfaSession from './apis/MfaSession.js'
import GapiModule from './gapiModule.js'
import StripeModule from './stripeModule.js'
import AnalyticsApi from './googleChart/index.js'
import PathHelper from './PathHelper.js'
import VModal from 'vue-js-modal'
import VueCookies from 'vue-cookies'
import VueHotkey from 'v-hotkey'
import money from 'v-money'
import qs from 'qs'
import vueCountryRegionSelect from 'vue-country-region-select'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { BPagination, BCarousel, BCarouselSlide, BProgress } from 'bootstrap-vue'
import Notifications from 'vue-notification'

library.add(faChevronLeft, faChevronRight)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('BPagination', BPagination)
Vue.component('b-carousel', BCarousel)
Vue.component('b-carousel-slide', BCarouselSlide)
Vue.component('b-carousel-slide', BCarouselSlide)
Vue.component('b-progress', BProgress)

Vue.config.productionTip = false
Vue.use(Questionnaire);
Vue.use(Cart);
Vue.use(User);
Vue.use(Coupon);
Vue.use(Vendor);
Vue.use(Design);
Vue.use(Ownership);
Vue.use(Organization);
Vue.use(MfaSession);
Vue.use(GapiModule);
Vue.use(StripeModule);
Vue.use(AnalyticsApi);
Vue.use(VModal)
Vue.use(VueRouter)
Vue.use(VueCookies)
Vue.use(PathHelper)
Vue.use(VueHotkey)
Vue.use(Article)
Vue.use(money)
Vue.use(Notifications)
Vue.use(vueCountryRegionSelect)

const routes = [
  { path: '/dashboard*', component: App },
  { path: '/shop*', component: App },
  { path: '/login', component: App },
  { path: '/signup', component: App },
  { path: '/vendor_registration', component: App },
  { path: '/remote_login', component: App },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_ROOT_PATH + '/',
  parseQuery(query) {
      return qs.parse(query);
  },
  stringifyQuery(query) {
    let result = qs.stringify(query)
    return result ? ('?' + result) : ''
  },
  routes
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
